import { Component, OnDestroy, OnInit } from '@angular/core';
import { AuthenticatorService } from '@aws-amplify/ui-angular';
import { CognitoService } from './services/cognito.service';
import { MenuProviderService } from './services/menu-provider.service';
import { filter, Subscription } from 'rxjs';
import { Auth } from 'aws-amplify';
import { environment } from 'src/environments/environment';
import { Event, NavigationEnd, Router } from '@angular/router';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  host: { class: 'mat-theme' }
})
export class AppComponent implements OnInit, OnDestroy {
  isAdmin = false;
  isOpen = false;
  isAuthenticated = false;
  private authSubscription: Subscription | null = null;
  userEmail = '';
  public enableReviewers = environment.features.enableReviewers;
  public enableNewAdvisor = environment.features.enableNewAdvisor;
  // Used for highlighting the current route in the sidenav
  currentRoute = this.router.url;

  constructor(
    public authenticator: AuthenticatorService,
    public cognitoService: CognitoService,
    private router: Router,
    private menuProvider: MenuProviderService
  ) {}

  ngOnInit() {
    document.documentElement.style.setProperty('--sidebar-width', this.isOpen ? '240px' : '64px');
    // Subscribe to authentication status
    this.authSubscription = this.cognitoService.isAuthenticated().subscribe(async isAuth => {
      this.isAuthenticated = isAuth;
      if (isAuth) {
        this.isAdmin = await this.cognitoService.isAdmin();
        this.menuProvider.setFlags(this.isAdmin, this.enableNewAdvisor, this.enableReviewers);
        this.getUserEmail();
      } else {
        this.isAdmin = false;
      }
    });

    this.router.events
      .pipe(filter((event: Event): event is NavigationEnd => event instanceof NavigationEnd))
      .subscribe((event: NavigationEnd) => {
        this.currentRoute = event.url;
      });
  }

  ngOnDestroy() {
    if (this.authSubscription) {
      this.authSubscription.unsubscribe();
    }
  }

  get menuItems() {
    return this.menuProvider.getMenuItems();
  }

  // toggle sidenav and alert service for other components that may need to know
  toggleSidenav() {
    this.isOpen = !this.isOpen;
    this.menuProvider.toggleSidebar(this.isOpen);
    document.documentElement.style.setProperty('--sidebar-width', this.isOpen ? '240px' : '64px');
  }

  async getUserEmail() {
    try {
      const email = await this.cognitoService.getUserEmail();
      this.userEmail = email;
    } catch (error) {
      console.error('Error retrieving user email:', error);
    }
  }

  async SsoSignIn() {
    try {
      await Auth.federatedSignIn({
        customProvider: 'azureadidp'
      });
    } catch (error) {
      console.log('Error signing in with Azure AD:', error);
    }
  }

  async logout() {
    try {
      await Auth.signOut();
      this.userEmail = '';
      this.isAuthenticated = false;
      this.isAdmin = false;
    } catch (error) {
      console.log('Error signing out:', error);
    }
  }
}
